var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"chart-display"},[(_vm.errorMsg)?_c('NoData',[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e(),(_vm.forceRerender)?_c('VueApexCharts',{attrs:{"width":"100%","height":"100%","type":"area","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }